import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { FormType, FormSectionDataType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    id: new FormControl(null),
    status: new FormControl(true, { nonNullable: true, validators: [Validators.required] }),
    title: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
    validTill: new FormControl(null),
    sortOrder: new FormControl(0, { nonNullable: true, validators: [Validators.required] }),

    pushTitle: new FormControl(null, [Validators.maxLength(50)]),
    pushText: new FormControl(null, [Validators.maxLength(178)]),
    pushSendOnDay: new FormControl(null),
    pushSendOnTime: new FormControl(null),

    bannerTitle: new FormControl(null, [Validators.maxLength(50)]),
    bannerBackground: new FormControl(null),
    bannerBackgroundPhotoId: new FormControl(null),

    sections: new FormArray<FormGroup>([]),
  });
};

export const createSection = () => {
  return new FormGroup<FormSectionDataType>({
    contentText: new FormControl(null, [Validators.maxLength(10000)]),
    products: new FormControl([], { nonNullable: true }),
  });
};
